<ng-template #seeProductList let-modal>
  <p class="p-2 w-100" style="font-size: 1.4rem; font-weight: bold; text-align: center"><i
      class="fa-solid fa-handshake"></i> Similar Products</p>

  <div class="prods px-3">
    <ng-container *ngFor="let list of searchProds">
      <common-product-card-view (view)="goToProduct($event)" [list]="list" [isCommunityProduct]="true">
      </common-product-card-view>
    </ng-container>
  </div>
  <p *ngIf="searchProds.length < 1" class="p-3" style="text-align: center; color: var(--primary)"><i
      class="fas fa-heart-broken"></i> No products found for your search</p>
</ng-template>

<div class="container-product-detail">
  <div class="d-flex justify-content-between">
    <app-breadcrumb *ngIf="productData" [data]="[
      {
        name: productData?.mainCategoryName,
        link: '/category/' + (productData?.mainCategorySlug ?? productData?.categoryName?.toLowerCase()?.replaceAll(' ', '-')),
        active: false,
      },

      {
        name: productData?.categoryName,
        link: '/category/' + (productData?.categorySlug ?? productData?.categoryName?.toLowerCase()?.replaceAll(' ', '-')),
        active: false,
      },
      {
        name: productData.name,
        link: '/product/' + productData.slug,
        active: true,
      },
    ]"></app-breadcrumb>
    @if(isOnMobile) {
    <div class="back-button-section">
      <button class="back-button" (click)="goBack()"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back</button>
    </div>
    }
  </div>
  <!-- isLoading: {{isLoading}} -->

  <div [class.product-page]="!isLoading">
    @if (!isLoading) { @if (!isOnMobile) {
    <div class="d-flex flex-column">
      <div class="d-flex justify-content-between" style="padding: 0rem 0rem 0.75rem">
        <div class="back-button-section">
          <button class="back-button" (click)="goBack()"><i class="fa fa-arrow-left" aria-hidden="true"></i>
            Back</button>
        </div>
      </div>
      <app-product-types-list [productId]="productData?.id" [categoryId]="productData?.categoryId" *ngIf="typesExist"
        (typeList)="setTypeList($event)"
        (typesExist)="typesExist = $event; realignSwiperIndexWhenTabsChange()"></app-product-types-list>
      <div style="width: 1" *ngIf="!typesExist"></div>

      <app-forum-list [forums]="productForums" (reloadForums)="loadForums()" [pageId]="productData?.id"
        type="product"></app-forum-list>
    </div>
    <div>
      <div
        style="background: #fff; padding: 0.25rem; margin-bottom: 1rem; border-radius: 0.5rem; box-shadow: 0 2px 4px #0000001a"
        *ngIf="enableMemberShop && productData; else notFound">
        <div class="d-flex flex-wrap w-100 mb-1" *ngIf="typeList?.length">
          <ng-container *ngFor="let type of typeList">
            <div *ngIf="isUserAnAdmin || productSubTypes.has(type.id)" class="d-flex mr-2">
              <input type="checkbox" *ngIf="isUserAnAdmin" (change)="handleSubTypeAssignment($event, type)"
                [checked]="productSubTypes.has(type.id)" />
              <!-- <label [for]="type.id" class="btn btn-sm btn-outline-primary" (click)="toggleType(type)">
            
              
            </label> -->
              <button class="btn btn-sm btn-outline-primary ml-2" (click)="searchSimilarSubType(type)">{{ type.name
                }}</button>
            </div>
          </ng-container>
        </div>
        <ng-container *ngIf="enableMemberShop && productData">
          <app-view-product-details [addProductComponent]="addProductComponent" [productData]="productData"
            [similarProducts]="similarProducts" [linkRfererUserId]="linkRfererUserId"> </app-view-product-details>
        </ng-container>
      </div>
    </div>
    <div class="d-flex flex-column justify-content-between faq-edit-your-product-container">
      <app-product-faq-list [additionalFAQS]="productData?.faqInfos" [categoryId]="productData?.categoryId"
        *ngIf="faqsExist" (faqsExist)="faqsExist = $event"></app-product-faq-list>
      <div style="width: 1" *ngIf="!faqsExist"></div>
      <!---
         span style="font-size: .8rem;">If you are the Product</span>
          <span></span>
      -->
      <div class="mt-2" *ngIf="isLogin && productData?.shoutContact == '65' + userPhoneNumber">
        <button class="btn btn-success d-flex flex-column justify-content-center align-items-center">
          <span style="font-size: 1.2rem" (click)="editCurrentProduct()">Edit Your Product</span>
        </button>
      </div>
      <div class="mt-2 position-relative w-100 d-flex justify-content-end" *ngIf="!isLogin && showLoginWizard">
        <div class="shadow p-4 position-absolute wizard-msg">
          <button class="t-btn close-btn" (click)="showLoginWizard = false"><i class="fa fa-x"></i></button>
          If you are the owner of owner of this service, you can login to edit your product. Ensure that you login using
          the same phone number being used for this service provided.
          <button style="color: var(--secondary)" class="t-btn" (click)="openLoginModal()">Login to edit my
            product</button>
        </div>
        <img src="../../../../../assets/images/w.jpeg" class="shadow login-wizard" />
      </div>
    </div>
    } @else {
    <div class="custom-swiper-2">
      <app-my-carousel-swiper class="product-mobile-swiper custom-swiper-2" (onSwiper)="initSwiper($event)"
        [config]="carOptions">
         <div class="swiper-slide" *ngIf="typesExist">
            <app-product-types-list [productId]="productData?.id" 
            (typeList)="setTypeList($event)" (typesExist)="typesExist = $event; realignSwiperIndexWhenTabsChange()" 
            [categoryId]="productData?.categoryId"></app-product-types-list>
            <app-forum-list [forums]="productForums" (reloadForums)="productForums()" [pageId]="productData?.id" type="product"></app-forum-list>

          </div> 

        <div class="swiper-slide">
          <!-- {{typesExist}} -->
          <div *ngIf="productData != null; else notFound">
            <div class="d-flex flex-wrap w-100 mb-1" *ngIf="typeList?.length">
              <button *ngFor="let type of typeList" class="btn btn-sm btn-outline-primary ml-2"
                (click)="searchSimilarSubType(type)">{{ type.name }}</button>
            </div>
            <app-view-product-details [productData]="productData" [similarProducts]="similarProducts"
              [linkRfererUserId]="linkRfererUserId"></app-view-product-details>
          </div>
        </div>
        <div class="swiper-slide" *ngIf="faqsExist">
          <app-product-faq-list [additionalFAQS]="productData?.faqInfos" [categoryId]="productData?.categoryId"
            *ngIf="faqsExist" (faqsExist)="faqsExist = $event"></app-product-faq-list>
        </div>
      </app-my-carousel-swiper>
    </div>
    }
    <ng-template #notFound>
      <div class="not-found-container">
        <img src="assets/images/no-found-products.png" alt="No Products" class="img-fluid mb-4" />
        <h1>404 - Not Found</h1>
        <p>The page or product you are looking for does not exist.</p>
      </div>
    </ng-template>
    } @else {
    <div class="loading-container mx-auto"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</div>
    }
  </div>
</div>
<app-add-shop #AddShop [enableMemberShop]="enableMemberShop" [isSingleProduct]="true"></app-add-shop>